import {
    deleteAuthenticated,
    getAuthenticated,
    patchAuthenticated,
    postAuthenticated,
    putAuthenticated
} from '../../../../../services/RestTemplate';

const teamsApi = '/teams';
const permissionsApi = '/permissions';
const jurisdictionsApi = '/jurisdictions';
const brandsApi = '/brands';

export const getTeams = () => getAuthenticated(teamsApi);

export const getTeamById = id => {
    const getTeamByIdUrl = teamsApi + `/${id}`;

    return getAuthenticated(getTeamByIdUrl);
};

export const addTeam = params => {
    const addTeamUrl = teamsApi;
    return postAuthenticated(addTeamUrl, params);
};

export const updateTeam = (teamId, params) => {
    const updateTeamUrl = teamsApi + `/${teamId}`;

    return patchAuthenticated(updateTeamUrl, params);
};

export const addPermissionToTeam = (teamId, params) => {
    const addPermissionToTeamUrl = teamsApi + `/${teamId}` + permissionsApi;
    return postAuthenticated(addPermissionToTeamUrl, params);
};

export const deletePermissionFromTeam = (teamId, permission) => {
    const deletePermissionFromTeamUrl =
        teamsApi + `/${teamId}` + permissionsApi + '/' + permission;
    return deleteAuthenticated(deletePermissionFromTeamUrl);
};

export const updateTeamJurisdictions = (teamId, jurisdictions) => {
    const addJurisdictionToTeamUrl = teamsApi + `/${teamId}` + jurisdictionsApi;
    return putAuthenticated(addJurisdictionToTeamUrl, jurisdictions);
};

export const deleteJurisdictionFromTeam = (teamId, jurisdictionCode) => {
    const removeJurisdictionFromTeamUrl =
        teamsApi + `/${teamId}` + jurisdictionsApi + '/' + jurisdictionCode;
    return deleteAuthenticated(removeJurisdictionFromTeamUrl);
};

export const addBrandToTeam = (teamId, jurisdictionCode, brandIds) => {
    const addBrandToTeamUrl =
        teamsApi +
        `/${teamId}` +
        jurisdictionsApi +
        `/${jurisdictionCode}` +
        brandsApi;
    return postAuthenticated(addBrandToTeamUrl, brandIds);
};

export const deleteBrandFromTeam = (teamId, jurisdictionCode, brandId) => {
    const removeBrandFromTeamUrl =
        teamsApi +
        `/${teamId}` +
        jurisdictionsApi +
        `/${jurisdictionCode}` +
        brandsApi +
        '/' +
        brandId;
    return deleteAuthenticated(removeBrandFromTeamUrl);
};
